import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Star, Quote, ChevronLeft, ChevronRight } from 'lucide-react';
const testimonials = [{
  id: 1,
  name: 'Sarah M.',
  project: 'Kitchen Remodel',
  quote: 'Absolutely thrilled with our new kitchen. The team was professional, clean, and their attention to detail was incredible. They finished exactly on schedule and there were no surprise costs.'
}, {
  id: 2,
  name: 'David & Lisa T.',
  project: 'Exterior Painting',
  quote: 'Our house looks brand new! The crew prepped everything meticulously before painting. They were polite, worked hard every day, and left the yard spotless when they finished.'
}, {
  id: 3,
  name: 'Michael R.',
  project: 'Full Home Renovation',
  quote: 'Finding a reliable contractor is hard, but these guys are the real deal. High-end finish work, great communication throughout the process, and truly beautiful results.'
}];
export function Testimonials() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const next = () => setCurrentIndex(prev => (prev + 1) % testimonials.length);
  const prev = () => setCurrentIndex(prev => (prev - 1 + testimonials.length) % testimonials.length);
  return <section className="py-20 md:py-32 bg-warmWhite overflow-hidden" data-id="element-173">
      <div className="container mx-auto px-4 md:px-6" data-id="element-174">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-175">
          <h2 className="font-heading text-3xl md:text-5xl font-bold text-charcoal tracking-tight mb-4" data-id="element-176">
            What Our Clients Say
          </h2>
          <div className="w-20 h-1 bg-gold mx-auto rounded-full" data-id="element-177" />
        </motion.div>

        {/* Desktop Grid */}
        <div className="hidden lg:grid grid-cols-3 gap-8 max-w-6xl mx-auto" data-id="element-178">
          {testimonials.map((testimonial, index) => <motion.div key={testimonial.id} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-white p-8 rounded-xl shadow-sm border border-warmGray relative" data-id="element-179">
              <Quote className="absolute top-6 right-6 w-12 h-12 text-warmGray/50" data-id="element-180" />
              <div className="flex gap-1 mb-6" data-id="element-181">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 text-gold fill-gold" data-id="element-182" />)}
              </div>
              <p className="text-charcoal/80 text-lg mb-8 relative z-10 italic leading-relaxed" data-id="element-183">
                "{testimonial.quote}"
              </p>
              <div className="mt-auto" data-id="element-184">
                <p className="font-bold text-charcoal" data-id="element-185">{testimonial.name}</p>
                <p className="text-sm text-charcoal/60" data-id="element-186">
                  {testimonial.project}
                </p>
              </div>
            </motion.div>)}
        </div>

        {/* Mobile/Tablet Carousel */}
        <div className="lg:hidden relative max-w-2xl mx-auto" data-id="element-187">
          <div className="overflow-hidden px-2 py-4" data-id="element-188">
            <AnimatePresence mode="wait" data-id="element-189">
              <motion.div key={currentIndex} initial={{
              opacity: 0,
              x: 50
            }} animate={{
              opacity: 1,
              x: 0
            }} exit={{
              opacity: 0,
              x: -50
            }} transition={{
              duration: 0.3
            }} className="bg-white p-8 rounded-xl shadow-sm border border-warmGray relative" data-id="element-190">
                <Quote className="absolute top-6 right-6 w-10 h-10 text-warmGray/50" data-id="element-191" />
                <div className="flex gap-1 mb-6" data-id="element-192">
                  {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 text-gold fill-gold" data-id="element-193" />)}
                </div>
                <p className="text-charcoal/80 text-base md:text-lg mb-8 relative z-10 italic leading-relaxed" data-id="element-194">
                  "{testimonials[currentIndex].quote}"
                </p>
                <div data-id="element-195">
                  <p className="font-bold text-charcoal" data-id="element-196">
                    {testimonials[currentIndex].name}
                  </p>
                  <p className="text-sm text-charcoal/60" data-id="element-197">
                    {testimonials[currentIndex].project}
                  </p>
                </div>
              </motion.div>
            </AnimatePresence>
          </div>

          <div className="flex justify-center gap-4 mt-6" data-id="element-198">
            <button onClick={prev} className="w-10 h-10 rounded-full border border-warmGray flex items-center justify-center text-charcoal hover:bg-warmGray transition-colors" aria-label="Previous testimonial" data-id="element-199">
              <ChevronLeft className="w-5 h-5" data-id="element-200" />
            </button>
            <button onClick={next} className="w-10 h-10 rounded-full border border-warmGray flex items-center justify-center text-charcoal hover:bg-warmGray transition-colors" aria-label="Next testimonial" data-id="element-201">
              <ChevronRight className="w-5 h-5" data-id="element-202" />
            </button>
          </div>
        </div>
      </div>
    </section>;
}